import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';



export const INITIAL_STATE = Immutable({
    isLoading: false,

    status: false,
    error: null,

    sendOtpStatus: false,
    otpSent: false,

    sendMagicLinkStatus: false,
    magicLinkSent: false
});



const initVerifyOTP = (state, action) => {
    return state.merge({
        isLoading: true,
        status: false,
        error: null,
    });
};


const responseVerifyOTP = (state, action) => {
    return state.merge({
        isLoading: false,
        status: action.response.ok,
        error: action.response.error
    });
};


const initSendOTP = (state, action) => {
    return state.merge({
        isLoading: true,
        sendOtpStatus: false,
        otpSent: false
    });
};


const responseSendOTP = (state, action) => {
    return state.merge({
        isLoading: false,
        sendOtpStatus: true,
        otpSent: action.response.ok
    });
};

const initSendMagicLink = (state, action) => {
    return state.merge({
        isLoading: true,
        sendMagicLinkStatus: false,
        magicLinkSent: false
    });
};

const responseMagicLink = (state, action) => {
    return state.merge({
        isLoading: false,
        sendMagicLinkStatus: true,
        magicLinkSent: action.response.ok
    });
};


const ACTION_HANDLERS = {
    [Types.VERIFY_OTP]: initVerifyOTP,
    [Types.RESPONSE_VERIFY_OTP]: responseVerifyOTP,
    [Types.SEND_OTP_PHONE]: initSendOTP,
    [Types.RESPONSE_SEND_OTP_PHONE]: responseSendOTP,
    [Types.SEND_MAGIC_LINK]: initSendMagicLink,
    [Types.RESPONSE_MAGIC_LINK]: responseMagicLink
};



export default createReducer(INITIAL_STATE, ACTION_HANDLERS)